class SellerInformation extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.data = [];
  }

  init = () => {
    this.sellerInformation();
    this.changeEvent();
  }

  changeEvent = () => {
    let input = this.querySelector('#product-sku');
    if (!input) {
      return;
    }
    input.addEventListener('change', (e) => {
      this.setSeller();
    })
  }

  sellerInformation = async () => {
    let id = this.dataset.id;
    let res = await this.sellerInformationApi(id);
    this.data = res.data?.data;
    this.setSeller();
  }

  setSeller = () => {
    if (this.data == []) {
      return;
    }
    let input = this.querySelector('#product-sku');
    let value = parseInt(input.value);
    let sellerData = this.data[value];
    if (!sellerData) {
      this.classList.add('hide');
      return;
    }
    let info = this.querySelector('.seller-info');
    let parent = this;
    if (sellerData.is_iconic) {
      info.classList.add('iconic');
      parent.classList.add("samarth-parent");
    } else {
      info.classList.remove('iconic');
      parent.classList.remove("samarth-parent");
    }
    if (sellerData.is_samarth) {
      info.classList.add('samarth');
    } else {
      info.classList.remove('samarth');
    }
    if (sellerData.is_iconic || sellerData.is_samarth) {
      this.classList.remove('hide');
    } else {
      this.classList.add('hide');
    }
  }
  
  toggleEvent = () => {
    let toggleBtn = document.querySelector('seller-information .view-more-btn') || null
    let seller_info = document.querySelector('seller-information .seller-info') || null
    if(toggleBtn){
      toggleBtn.addEventListener("click",()=>{
        if(seller_info.classList.contains("more-hide")){
          seller_info.classList.remove("more-hide")
        }
        else{
          seller_info.classList.add("more-hide")
        }
      })
    }
  }

  sellerInformationApi = async (id) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("shop", "\"gant-india.myshopify.com\"");
      myHeaders.append("product_id", id);

      let res = await fetch("https://xsa9cbbapk.execute-api.ap-south-1.amazonaws.com/iconicwebapi", {
        method: 'GET',
        headers: myHeaders
      });
      res = await res.json();
      this.toggleEvent()
      return { status: 0, data: res };
    }
    catch (e) {
      return { status: 1, error: e.message }
    }
  }

}

customElements.define('seller-information', SellerInformation);